<template>
	<div class="page">
		<div title="talentTemplate" is='headered'></div>
		<div class="talentTop">
			<div class="title">
				<div>人才成长的终身导师</div>
			</div>
			<!--<img class="talentImg" src="../assets/index_img1.png"/>-->
			<img class="talentImg" src="../assets/talent_img1.png"/>
		</div>
		<!--人才板块主体内容-->
		<div class="talentBox">
			<div class="talentBox_l">
				<div ref='talentBox_l_fix' class="talentBox_l_main" v-bind:class="{'talentBox_l_fix':scrollSel}">
					<div v-bind:class="{'talentBox_l_sel':talentBox_l_Index==0}" @click="changeTalent(0)">少年阶段</div>
					<div v-bind:class="{'talentBox_l_sel':talentBox_l_Index==1}" @click="changeTalent(1)">青年阶段</div>
					<div v-bind:class="{'talentBox_l_sel':talentBox_l_Index==2}">成年阶段</div>
				</div>
			</div>

			<div class="talentBox_r">
				<!--少年阶段-->
				<div id="talentBox_item1" class="talentBox_item">
					<div class="talentBox_df">
						<div class="title">少年阶段</div>
						<div class="s_title">自我管理、创新发展</div>
					</div>
					<div @click="tojuvenPage()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">小小项目师、少年发明家</div>
								<div class="talentText">青少年自我管理、发明创造、项目制PBL教学</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>
					</div>
				</div>
				<!--青年阶段-->
				<div id="talentBox_item2" class="talentBox_item">
					<div class="talentBox_df">
						<div class="title">青年阶段</div>
						<div class="s_title">项目管理、挥斥方遒</div>
					</div>
					<div @click="toyoungPage1()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">1+X职业技能等级证书</div>
								<div class="talentText">国务院教育部1+X职业技能等级证书的培训评价组织</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>
					</div>
					<div  @click="toyoungPage2()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">高校双创就业指导</div>
								<div class="talentText">提供高校双创（创新与创业）项目式案例就业指导</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>
					</div>
					<div @click="toyoungPage3()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">项目管理本科在线视频慕课</div>
								<div class="talentText">同时容纳5000人以上的在线视频慕课平台</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>	
					</div>
					<div  @click="toyoungPage4()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">在线法国MBA硕士</div>
								<div class="talentText">系统学习工商管理课程，培养学生全球化视野</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>
					</div>
				</div>
				<!--成年阶段-->
				<div id="talentBox_item3" class="talentBox_item">
					<div class="talentBox_df">
						<div class="title">成年阶段</div>
						<div class="s_title">运筹帷幄、决胜千里</div>
					</div>
					<div  @click="toadultPage()" class="talentItem">
						<div class="talentItem_l">
							<img class="talentItem_img" src="../assets/talentLogo.png"/>
							<div>
								<div class="talentName">"全球通"国际项目经理IPMP认证</div>
								<div class="talentText">国际项目管理协会IPMA60年代起在近百个国家推行的"全球通"证书</div>			
							</div>
						</div>
						<div class="talentItem_r">查看详情 ></div>
					</div>
				</div>
			</div>
		</div>
		<!--公共底部-->
		<div is='footed'></div>
	</div>
</template>

<script>
	import headered from '@/components/header';
	import footed from '@/components/foot';
	export default {
		name: 'index',
		components: {
			headered,
			footed
		},
		data() {
			return {
				scrollSel: false, //判断左侧阶段是否固定定位
				talentBox_l_Index: 0, //控制当前选中的左侧阶段
			}
		},
		created() {

		},
		mounted() {
			window.addEventListener('scroll', this.scrolled);
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrolled);
		},
		methods: {
			scrolled() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;　
				let num = (window.document.documentElement.offsetWidth - 1200) / 2
				this.$refs.talentBox_l_fix.style.left=(num-1200)/2
				if(scrollTop < 410) {
					this.scrollSel = false;
					this.talentBox_l_Index = 0;
				} else if(scrollTop >=410 && scrollTop < 665) {
					this.scrollSel = true;
					this.talentBox_l_Index = 0;
				} else if(scrollTop >=665&& scrollTop < 1420) {
					this.scrollSel = true;
					this.talentBox_l_Index = 1;
				} else if(scrollTop >=1420) {
					this.scrollSel = true;
					this.talentBox_l_Index = 2;
				} 
			},
			changeTalent(index) {
				this.talentBox_l_Index = index;
				if(index == 0) {
					this.goTo(446)
				} else if(index == 1) {
					this.goTo(665)
				}
			},
			goTo(target) {
				var scrollT = document.body.scrollTop || document.documentElement.scrollTop
				if(scrollT > target) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(-scrollT / 50);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						if(scrollT <= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}

					}, 10)

				} else if(scrollT == 0) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(300 / 5 * 0.7);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						console.log(scrollT)
						if(scrollT >= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}
					}, 10)
				} else if(scrollT < target) {
					var timer = setInterval(function() {
						var scrollT = document.body.scrollTop || document.documentElement.scrollTop
						var step = Math.floor(scrollT / 50);
						document.documentElement.scrollTop = document.body.scrollTop = step + scrollT;
						if(scrollT >= target) {
							document.body.scrollTop = document.documentElement.scrollTop = target;
							clearTimeout(timer);
						}

					}, 10)

				} else if(target == scrollT) {
					return false;
				}
			},
//			少年阶段
			tojuvenPage(){
				this.$router.push({
					path: '/juvenileStage'
				});
			},
//			青年阶段
			toyoungPage1(){
				this.$router.push({
					path: '/youngStage1'
				});
			},
			toyoungPage2(){
				this.$router.push({
					path: '/youngStage2'
				});
			},
			toyoungPage3(){
				this.$router.push({
					path: '/youngStage3'
				});
			},
			toyoungPage4(){
				window.open('https://www.esc-amiens.cn/#/')
			},
			toadultPage(){
				this.$router.push({
					path: '/adultStage'
				});
			}
		}
	}
</script>

<style scoped="scoped">
	/*顶部*/
	
	.talentTop {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 30px;
	}
	
	.talentTop>.title {
		height: 387px;
		padding-top: 96px;
	}
	
	.talentTop>.title div {
		line-height: 63px;
		font-size: 48px;
		text-align: left;
		font-weight: bold;
	}
	
	.talentTop .talentImg {
		width: 690px;
		height: 387px;
		border-radius: 10px;
	}
	/*人才板块主体内容*/
	
	.talentBox {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: flex-start;
		margin-bottom: 120px;
	}
	/*左侧控制栏*/
	
	.talentBox_l {
		width: 100px;
		height: 146px;
	}
	
	.talentBox_l_main {
		width: 100px;
		height: 126px;
		border-left: 2px solid #EFF0F1;
	}
	
	.talentBox_l_fix {
		width: 100px;
		height: 126px;
		position: fixed;
		top: 90px;
		/*left: 360px;*/
		border-left: 2px solid #EFF0F1;
	}
	
	.talentBox_l_main>div {
		cursor: pointer;
		position: relative;
		width: 100px;
		text-align: right;
		margin-bottom: 27px;
		line-height: 24px;
		font-size: 18px;
		color: #51565D;
	}
	
	.talentBox_l_main>div:nth-child(3) {
		margin-bottom: 0px;
	}
	
	.talentBox_l_main>.talentBox_l_sel {
		color: #4A7CFF;
	}
	
	.talentBox_l_main>.talentBox_l_sel::after {
		content: "";
		display: block;
		width: 2px;
		height: 24px;
		background-color: #4A7CFF;
		position: absolute;
		left: -2px;
		bottom: 0px;
	}
	/*右侧主体栏*/
	
	.talentBox_r {
		width: 792px;
	}
	
	.talentBox_item {
		margin-bottom: 40px;
	}
	.talentBox_item .talentBox_df{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-end;
		margin-bottom: 20px;
	}
	.talentBox_item1 {
		margin-bottom: 40px;
	}
	
	.talentBox_item2 {
		margin-bottom: 40px;
	}
	
	.talentBox_item3 {
		margin-bottom: 40px;
	}
	
	.talentBox_item .talentBox_df .title {
		line-height: 48px;
		font-size: 36px;
		font-weight: bold;
		text-align: left;
		margin-left: 24px;
	}
	
	.talentBox_item .talentBox_df .s_title {
		line-height: 26px;
		font-size: 20px;
		text-align: left;
		margin-left: 15px;
		margin-bottom:4px;
	}
	
	
	.talentBox_item>.talentItem{
		width: 816px;
		padding: 10px 24px;
		background: #FFFFFF;
		margin-bottom: 10px;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		/*box-shadow: 0px 8px 14px rgba(150, 150, 150, 0.16);*/
		box-shadow: 0px 6px 14px rgba(150, 150, 150, 0.8);
		align-items: center;
		cursor: pointer;
	}
	/*.talentBox_item>.talentItem:hover{
		box-shadow: 0px 8px 14px rgba(150, 150, 150, 0.16);
	}*/
	.talentItem .talentItem_l{
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.talentItem .talentItem_img{
		width: 16px;
		height: 16px;
		margin-top: 4px;
		margin-right: 5px;
	}
	.talentItem .talentName{
		line-height: 26px;
		font-size: 20px;
		color: #0080FF;
		font-weight: bold;
		margin-bottom: 8px;
		text-align: left;
	}
	.talentItem .talentText{
		line-height: 24px;
		font-size: 16px;
		color: #51565D;
		text-align: left;
	}
	.talentItem .talentItem_r{
		padding: 6px 12px;
		background: rgba(0,128,255,.1);
		border-radius: 4px;
		line-height: 24px;
		font-size: 16px;
		color: #0080FF;
	}
</style>


// WEBPACK FOOTER //
// src/views/talentTemplate.vue